"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EmailInput_1 = __importDefault(require("./EmailInput"));
exports.default = EmailInput_1.default;
